export const P0003606DureeLimiteSurdosage = [
  { label: '24 h 00', ref: 24 },
  { label: '25 h 00', ref: 25 },
  { label: '26 h 00', ref: 26 },
  { label: '27 h 00', ref: 27 },
  { label: '28 h 00', ref: 28 },
  { label: '29 h 00', ref: 29 },
  { label: '30 h 00', ref: 30 },
  { label: '31 h 00', ref: 31 },
  { label: '32 h 00', ref: 32 },
  { label: '33 h 00', ref: 33 },
  { label: '34 h 00', ref: 34 },
  { label: '35 h 00', ref: 35 },
  { label: '36 h 00', ref: 36 },
  { label: '37 h 00', ref: 37 },
  { label: '38 h 00', ref: 38 },
  { label: '39 h 00', ref: 39 },
  { label: '40 h 00', ref: 40 },
  { label: '41 h 00', ref: 41 },
  { label: '42 h 00', ref: 42 },
  { label: '43 h 00', ref: 43 },
  { label: '44 h 00', ref: 44 },
  { label: '45 h 00', ref: 45 },
  { label: '46 h 00', ref: 46 },
  { label: '47 h 00', ref: 47 },
  { label: '48 h 00', ref: 48 },
];
